if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => {
      reg.unregister().then(() => {
        console.log("Old service worker unregistered");
      });
    });
  });
}
